import { SortCriterion } from 'src/shared/api';
import { Params, ParamMap } from '@angular/router';

const SORT_CRITERIA_KEY = 'sc';

export const toSortingParams = (args: {
	sortCriteria?: SortCriterion[];
}): Params => ({
	[SORT_CRITERIA_KEY]: args.sortCriteria
		? args.sortCriteria.map(
				(sc) => `${sc.sortKey}|${sc.isDescending ? 'desc' : 'asc'}`
		  )
		: undefined,
});

export const toSortingListArgs = (
	paramMap: ParamMap
): { sortCriteria?: SortCriterion[] } =>
	paramMap.has(SORT_CRITERIA_KEY)
		? {
				sortCriteria: paramMap
					.getAll(SORT_CRITERIA_KEY)
					.map((param) => ({
						sortKey: param.split('|')[0],
						isDescending: param.split('|')[1] === 'desc',
					})),
		  }
		: undefined;
